import { Card, Spin } from "antd";
import React, { useEffect, useState } from "react";
import SupervisionService from "../../../../services/SupervisionService";
import { SupervisionWarehouse } from "../../../../models/Supervision";
import { useLanguage } from "../../../../context/LanguageContext";
import SupervisionRefactorTable from "./subcomponents/SupervisionRefactorTable";

const SupervisionRefactor: React.FC = () => {
  const { language } = useLanguage();
  const [supervisionWarehouses, setSupervisionWarehouses] = useState<SupervisionWarehouse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    SupervisionService.getSupervisionWarehouses()
      .then((supervisionWarehouse) => {
        setSupervisionWarehouses(supervisionWarehouse || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch warehouses:", error);
        setLoading(false);
      });
  }, []);

  return (
    <Card
      title={language === "es" ? "Supervisión de Pallets" : "Pallet Supervision"}
      style={{ margin: "20px" }}
    >
      <Spin spinning={loading}>
        <SupervisionRefactorTable supervisionWarehouses={supervisionWarehouses} />
      </Spin>
    </Card>
  );
};

export default SupervisionRefactor;